module.exports = __webpack_public_path__ + "img/Uzbekistán.699ca9a0.svg";